// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/// <reference path="../../../node_modules/@types/emscripten/index.d.ts" />
export const DIR_MODE = 16895; // 040777
export const FILE_MODE = 33206; // 100666
export const SEEK_CUR = 1;
export const SEEK_END = 2;
export function instanceOfStream(nodeOrStream) {
    return 'node' in nodeOrStream;
}
//# sourceMappingURL=emscripten.js.map